import { useEffect } from "react";
import { usePrevious, useScrollToElement } from "hooks";

const useScrollToDoctors = (page: number, show: boolean) => {
  const prevPage = usePrevious(page);
  const prevShow = usePrevious(show);
  const { ref, scrollToElement } = useScrollToElement();

  useEffect(() => {
    if (prevPage !== undefined && prevPage !== page) {
      scrollToElement();
    }
  }, [prevPage, page, scrollToElement]);

  useEffect(() => {
    if (prevShow !== undefined && !prevShow && show) {
      scrollToElement();
    }
  }, [prevShow, show, scrollToElement]);

  return ref;
};

export { useScrollToDoctors };
